module.exports = __webpack_public_path__ + "static/media/xqz.f089bc5a.jpg";